import { useNavigate } from "react-router-dom";
import { Button } from "@nextui-org/react";
import { faBars } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Breakpoint, useBreakpoint } from "cenero-ui-library";
import logo from "@/assets/images/logo.svg";

// ---------------------- Component

const PageHeader = () => {
  // --------- Variables / Hooks

  const navigate = useNavigate();

  const breakpoint = useBreakpoint();

  // --------- JSX

  if (breakpoint > Breakpoint.sm) return <></>;

  return (
    <header className="relative mb-2 flex h-auto w-screen max-w-[768px] items-center px-2 xs:mb-4 xs:mt-3 xs:px-6 sm:mb-6 sm:mt-6 sm:px-8 md:max-w-none">
      {/*******************************************/}
      {/* Menu */}
      {/*******************************************/}

      <Button
        isIconOnly
        radius="full"
        className="flex-none bg-transparent p-2 text-current transition-all duration-200"
        onPress={() => navigate("/menu")}
      >
        <FontAwesomeIcon
          icon={faBars}
          className="h-5 text-gray-600 dark:text-gray-300 xs:h-5"
        />
      </Button>

      {/*******************************************/}
      {/* App Logo */}
      {/*******************************************/}

      <div className="absolute left-1/2 mx-auto -translate-x-1/2">
        <img
          alt="Field Service Logo"
          src={logo}
        />
      </div>
    </header>
  );
};

export default PageHeader;
